<template>
  <div>
    <v-menu
      dark
      transition="slide-y-transition"
      :close-on-content-click="false"
      :nudge-width="150"
      v-model="displayMenuCompte"
      offset-y
    >
      <template v-slot:activator="{ on }" :items="this.user">
        <v-btn text v-on="on" :class="{ unswitch: user.switched }">
          <span>{{ user.displayName }}</span>
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-card>
        <div v-if="this.hasSwitchUser">
          <v-list>
            <v-list-item>
              <v-text-field
                @keyup.enter="switchUser"
                v-model="idUserToSwitch"
                label="Identifiant"
              ></v-text-field>
              <v-btn @click="switchUser" color="indigo">Switch !</v-btn>
            </v-list-item>
          </v-list>
        </div>
        <v-divider></v-divider>
        <v-list>
          <BaseUserMenu />
          <v-list-item v-if="!this.user.switched" :href="logoutUrl">
            <v-icon left>mdi-logout</v-icon>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click.prevent="unswitchUser">
            <v-list-item-title>Fin du switch</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseUserMenu from "@/components/base/BaseUserMenu";

export default {
  name: "BaseUser",
  components: { BaseUserMenu },
  data() {
    return {
      // UID utilisateur switché
      idUserToSwitch: null,
      // Variables d'ajustements graphiques
      displayMenuCompte: false,
      // une erreur lors du switch (utilisateur non trouvé)
      switchNotFoundError: false,
      // URL de déconnexion
      logoutUrl:
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOGOUT,
    };
  },
  computed: {
    ...mapState(["user", "loading"]),

    hasSwitchUser: function () {
      return this.user.roles.indexOf(process.env.VUE_APP_SWITCH_ROLE) > -1;
    },
  },
  methods: {
    // se connecter en tant que...
    async switchUser() {
      this.$store.commit("setEcranChargement", true);
      try {
        await this.$store.dispatch("switchUser", this.idUserToSwitch);
        this.displayMenuCompte = false;
        this.idUserToSwitch = "";
        this.$toast.success("Switch effectué !");
        this.$forceUpdate();
        window.location = process.env.VUE_APP_HOST_URL;
      } catch (error) {
        this.$toast.error("L'utilisateur demandé n'a pas été trouvé");
      } finally {
        this.$store.commit("setEcranChargement", false);
      }
    },
    // mettre fin à la connexion en tant que...
    async unswitchUser() {
      this.$store.commit("setEcranChargement", true);
      try {
        this.$store.dispatch("unswitchUser");
        this.$toast.success("Switch désactivé !");
        window.location = process.env.VUE_APP_HOST_URL;
      } catch (error) {
        this.$toast.error("Un problème est survenu lors de la déconnexion");
      } finally {
        this.displayMenuCompte = false;
        this.$store.commit("setEcranChargement", false);
      }
    },
  },
};
</script>

<style scoped>
.unswitch {
  background-color: #e22 !important;
}
</style>
